<template>


    <div id="vvideo">

        <div id="ztvleft">
            <div id="videoHistorywrap">
                <div id="videoHistory"></div>
            </div>
            <ul id="videoctr">
                <li><Button @click="isList = !isList" size="small">{{ isList ? '轨道模式' : '列表模式' }}</Button></li>
                <li><Button @click="close" size="small">全部关闭</Button></li>
                <li> <Select v-if="false" size="small" @on-change="channelChange" style="width: 100px"
                        v-model="videoModal">
                        <Option v-for="(y, index1) in videoModals" :value="y" :key="y">{{
                            y
                        }}</Option>
                    </Select>
                </li>
                <li>
                    <div style="line-height: 24px;">
                        <span style="margin-right: 10px;">
                            时间段
                        </span>
                        <span>
                            {{ startText }} 到 {{ endText }}
                        </span>
                    </div>
                </li>

            </ul>
            <div id="videotool">
                <videoTool :isList="isList" :isLoading="isLoading" @play="bofang" @downLoad="downloadFile"
                    ref="videoTool" @alot="alot"></videoTool>
            </div>
        </div>
        <div v-show="false" id="ztvright">
            <div id="vvmap">
                <my-map ref="locus" :isNavg="true" type="car">
                    <historyWindow ref="historyWindow"></historyWindow>

                </my-map>
            </div>
            <div id="vmaplist" v-if="false">
                <tlist @row="reRow" :tableData="tableData">

                </tlist>
            </div>
        </div>
        <Modal width="300" v-model="openDetail" title="历史片段详情" footer-hide>
            <Row>
                <Col span="24"><ly-form-item label="通道号" lw="6">{{
                    alotItem.channel
                }}</ly-form-item></Col>
                <Col span="24"><ly-form-item label="文件大小" lw="6">{{ alotItem.size }}M</ly-form-item></Col>
                <Col span="24"><ly-form-item label="开始时间" lw="6">{{
                    alotItem.begintime2
                }}</ly-form-item></Col>
                <Col span="24"><ly-form-item label="结束时间" lw="6">{{
                    alotItem.endtime2
                }}</ly-form-item></Col>
                <Col span="24"><ly-form-item label="设备号" lw="6">{{
                    alotItem.device
                }}</ly-form-item></Col>
                <Col span="24"><ly-form-item label="片段时长" lw="6">{{ alotItem.duration }}分钟</ly-form-item></Col>
            </Row>
            <Row style="margin-top: 30px">
                <Col span="24"><Button long type="primary" @click="downloadFile">下载该片段</Button></Col>
            </Row>
        </Modal>
    </div>

</template>
<script>
import videoTool from "./videoTool.vue";
import myTree from "../locate/locateToolCarPerson.vue";
import myMap from "../map/locusMap.vue";
import historyWindow from "./historyWindow.vue"
import tlist from "./tlist.vue";

let playList = [];
let player = null;
let tidObj = null;
let allChannelArr = [];
var jishiqi = null;
export default {
    components: { videoTool, myTree, myMap, tlist, historyWindow },
    data() {
        return {
            isPlay: false,
            split: "240",
            channel: 0, //1078协议设备，通道号传0表示查所有通道。GA系列设备传1,2,3,4这种
            openVideo: false,
            playing: {},
            tableForm: {
                carNo: "",
                deviceNo: "",
            },
            recolist: [],
            startText: '0000-00-00 00:00:00', //时间戳，用来显示时间轴
            endText: '0000-00-00 00:00:00', //时间戳，用来显示时间轴

            list: [],
            openDetail: false,
            alotItem: {
                start: 0,
                channel: 1,
                device: "16200135025",
                end: 0,
                filesize: 0,
            },
            tableData: [],//s所有轨迹数据
            selectTableData: [],//选中片段轨迹数据

            start: 0,
            end: 0,
            isLoading: false,
            playnow: {},
            videoModal: '单路回放',
            videoModals: ['单路回放', '多路回放'],
            tongdao: [1],
            windowsNumber: 1,
            time: null,
            isList: false,
        };
    },
    methods: {
        reach(v) {
            this.tableForm = v;
            console.log(v);
            this.chaxun();
            this.chaguiji();
            
        },
        beforCcreatePlayer() {
            if (player != null) {
                player.destroy();
                player = null;
                playList = [];
                tidObj = null;
                this.videoModal = false;
                this.isPlay = true;
                setTimeout(() => {
                    this.createPlayer();
                }, 100);
            } else {
                this.createPlayer();
            }
        },
        createPlayer() {
            player = new byskplayer({
                id: "videoHistory", //容器
                baseURL: "wss://videostream.car900.com", //路径
                //baseURL: 'wss://videostream.car900.com/07B7ED0A57724C7705F2C27E13ED57DA',
                // userkey: "c4d1fbb6-2dc5-4f86-a5da-893f80e9d80a", //客户代码
                userkey: "2161e23a-4d3b-4d1a-bf0a-cafd56f9c6f8", //客户代码
                //userkey: '9c6386c7-4987-4a30-ac90-43ad22900a9f',
                isReal: false, //是否实时
                isRecord: true, //是否回放
                userId: "apidemo", //用户id,
                click: this.onPlayClick,
                playstart: this.onPlayStart,
                playend: this.onPlayEnd,
                isSwitchCodetypeOnFullscreen: false, //全屏是否切换高清，默认false
            });

            //player.poster = "static/poster.png"; //设置预览图片
            player.setPlayerNum(this.windowsNumber); //设置视频画面
            player.autoCloseTime = 5; //设置播放5分钟后自动关闭视频
        },

        //查询历史数据
        chaxun() {
            /* this.recolist = [
                {
                    "alarmSign": 0,
                    "begintime": 1715733166000,
                    "channel": 3,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715736401000,
                    "fileName": 0,
                    "filesize": 194008111,
                    "storgetype": 1
                },
                {
                    "alarmSign": 0,
                    "begintime": 1715733166000,
                    "channel": 4,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715736401000,
                    "fileName": 0,
                    "filesize": 192987213,
                    "storgetype": 1
                },
                {
                    "alarmSign": 0,
                    "begintime": 1715733166000,
                    "channel": 1,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715734218000,
                    "fileName": 0,
                    "filesize": 251340379,
                    "storgetype": 1
                },
                {
                    "alarmSign": 0,
                    "begintime": 1715733166000,
                    "channel": 2,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715734176000,
                    "fileName": 0,
                    "filesize": 241308876,
                    "storgetype": 1
                },
                {
                    "alarmSign": 0,
                    "begintime": 1715734176000,
                    "channel": 2,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715735228000,
                    "fileName": 0,
                    "filesize": 251339845,
                    "storgetype": 1
                },
                {
                    "alarmSign": 0,
                    "begintime": 1715734218000,
                    "channel": 1,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715735270000,
                    "fileName": 0,
                    "filesize": 251343244,
                    "storgetype": 1
                },
                {
                    "alarmSign": 0,
                    "begintime": 1715735228000,
                    "channel": 2,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715736283000,
                    "fileName": 0,
                    "filesize": 252058062,
                    "storgetype": 1
                },
                {
                    "alarmSign": 0,
                    "begintime": 1715735270000,
                    "channel": 1,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715736338000,
                    "fileName": 0,
                    "filesize": 255165201,
                    "storgetype": 1
                },
                {
                    "alarmSign": 0,
                    "begintime": 1715736283000,
                    "channel": 2,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715736401000,
                    "fileName": 0,
                    "filesize": 26648917,
                    "storgetype": 1
                },
                {
                    "alarmSign": 0,
                    "begintime": 1715736338000,
                    "channel": 1,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715736397000,
                    "fileName": 0,
                    "filesize": 13314064,
                    "storgetype": 1
                },
                {
                    "alarmSign": 0,
                    "begintime": 1715737084000,
                    "channel": 1,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715737416000,
                    "fileName": 0,
                    "filesize": 79246711,
                    "storgetype": 1
                },
                {
                    "alarmSign": 0,
                    "begintime": 1715737084000,
                    "channel": 2,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715737416000,
                    "fileName": 0,
                    "filesize": 79008759,
                    "storgetype": 1
                },
                {
                    "alarmSign": 0,
                    "begintime": 1715737084000,
                    "channel": 3,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715737416000,
                    "fileName": 0,
                    "filesize": 20142708,
                    "storgetype": 1
                },
                {
                    "alarmSign": 0,
                    "begintime": 1715737084000,
                    "channel": 4,
                    "codetype": 1,
                    "datatype": 0,
                    "device": "13306742239",
                    "endtime": 1715737416000,
                    "fileName": 0,
                    "filesize": 19970697,
                    "storgetype": 1
                }
            ]
            this.chuli(); return; */
            console.log(this.tableForm.deviceNo)
            this.isLoading = true;
            let params = {
                device: this.tableForm.deviceNo, //终端号
                channel: this.channel, //通道号
                protocolType: 1, //协议类型，1：GF-1078，2：GA系列
                begintime: Math.round(this.tableForm.startTime / 1000), //开始时间（时间戳，精确至秒）
                endtime: Math.round(this.tableForm.endTime / 1000), //结束时间（时间戳，精确至秒）
                alarmSign: 0, //报警类型（目前只支持：0）
            };


            player.record.query(params, (res) => {
                this.isLoading = false;
                console.log('历史视频数据', res)
                if (res.status == 1) {
                    this.recolist = res.recordfiles;

                    // console.log(this.recolist);

                    this.chuli();
                } else {
                    this.$Message.error('获取数据失败')
                }
            });
        },
        //查询轨迹
        chaguiji() {
            return;
            console.log('查询开始时间', this.utils.time(this.tableForm.startTime));
            console.log('查询结束时间', this.utils.time(this.tableForm.endTime));
            let params = {
                deviceNo: this.tableForm.deviceNo, //终端号
                returnCoord: 2, //1-WGS84，2-GCJ-02，3-BD-09）
                startTime: this.tableForm.startTime, //开始时间（时间戳，精确至秒）
                endTime: this.tableForm.endTime, //结束时间（时间戳，精确至秒）
                //startTime: 1715733166000, //开始时间（时间戳，精确至秒）
                //endTime: 1715737084000, //结束时间（时间戳，精确至秒）
                //deviceNo: 13306742239, //终端号
            };
            this.axios({
                method: "post",
                //url: this.axios.lbs + "/locus/getPlyLocus",
                url: this.axios.lbs + "/locus/getOrgLocus",
                data: params,
            }).then((res) => {

                var data = res.data.data.dataList;

                if (res) {
                    if (data.length >= 1) {

                        for (let i = 0; i < data.length; i++) {


                            //data[i].tms = data[i].gpsTime / 1000;
                            data[i].locateLng = data[i].returnX;
                            data[i].locateLat = data[i].returnY;

                            data[i].gpsTime1 = this.utils.time(data[i].gpsTime);
                            data[i].accStatus1 = this.$t("accStatus." + data[i].accStatus);
                            /* if (data[i].speed == 0) {
                              data[i].parkDuration = 5;
                            } */

                        }



                        //this.$refs.locus.showpark(data, 3); //停车点
                    } else if (data.length == 0) {
                        this.$Message.error("暂无轨迹");
                        this.$refs.locus.loadUi([], []); //清空轨迹
                        this.$refs.locus.showpark([], 0); //清空停车点
                        //this.$refs.locus.showPoints(this.list);
                        this.$store.state.control = false;
                    }
                }
                this.tableData = data.reverse();
                console.log('查询到的轨迹', this.tableData);
            })
        },
        //渲染轨迹
        xuanranguiji() {
            return;
            var lnglat = [];
            var data = [];

            console.log('是屁播放开始', this.utils.time(this.playnow.start));
            console.log('视频播放结束', this.utils.time(this.playnow.end));
            for (let i = 0; i < this.tableData.length; i++) {
                if (this.tableData[i].gpsTime >= this.playnow.start * 1000 && this.tableData[i].gpsTime <= this.playnow.end * 1000) {
                    //console.log(this.utils.time(this.tableData[i].gpsTime), this.utils.time(this.playnow.start * 1000));
                    data.push(this.tableData[i])
                    lnglat.push([this.tableData[i].returnX, this.tableData[i].returnY]);
                }

            }
            this.selectTableData = data;

            this.$refs.locus.loadUi(lnglat, data); //渲染轨迹
            this.showWin();

        },
        //获取当前播放点
        showWin(t) {
            return;
            var data = this.selectTableData;
            var now = null;
            if (t) {
                console.log('播放时间:' + this.utils.time(t * 1000));

                for (let i = 0; i < data.length; i++) {
                    //取刚好小于的那个点，然后取出上一个即可
                    if (t * 1000 <= data[i].gpsTime) {
                        console.log('tttttt');
                        let m = i < 1 ? 0 : i
                        now = data[m];
                        break;
                    }

                }
                if (now == null) {
                    now = data[0];
                }

            } else {
                now = data[0]
            }

            console.log('现在展示点', now);
            this.$refs.historyWindow.reach(now);
            this.$refs.locus.showWin(now);
        },
        //隐藏轨迹
        yincangguiji() {
            this.$refs.locus.loadUi([], []); //渲染轨迹
            this.$refs.locus.hideWin();
        },
        //单通道和多通道转换
        channelChange(v) {
            this.close();
            if (v == '单路回放') {
                this.windowsNumber = 1;
                this.tongdao = [1]
            } else {
                this.windowsNumber = 9;
                this.tongdao = [1, 2, 3, 4]
            }
            player.setPlayerNum(this.windowsNumber); //设置视频画面
        },
        reRow() { },
        bofang(v) {
            console.log('开始播放',v);
            
            this.close();
            this.playnow = v;
            this.xuanranguiji();
            this.startText = this.utils.time(v.start * 1000);
            this.endText = this.utils.time(v.end * 1000);


            this.time = setTimeout(() => {
                var channelArr = this.tongdao;
                if (this.videoModal == '单路回放') {
                    channelArr = [v.channel];
                }

                this.playing = v;

                this.isPlay = true;
                this.videoModel = true;
                let playerType = 0;
                let SpecialSign = 0; //0不处理 1--粤标
                if (this.tableForm.deviceModel.indexOf("GH11") != -1) {
                    playerType = 1;
                    console.log('GH11成功');
                };
                if (this.tableForm.deviceProtocol.indexOf("粤标") != -1 ||
                    this.tableForm.deviceProtocol.indexOf("809") != -1) {
                    // playerType = 1;
                    SpecialSign = 1;
                }
                let params = {
                    playerType,
                    device: this.tableForm.deviceNo,
                    // channel: v.channel,
                    protocolType: 1,//协议类型 1 1078 2，ga
                    SpecialSign,
                    datatype: 0,//GB-1078音视频分离
                    begintime: v.start,
                    endtime: v.end,
                    codetype: 2,// 0: 高清; 1: 标清 2: qita 
                };

                //console.log(params);
                //const T = protocolTypeDom.options[protocolTypeDom.selectedIndex].innerText
                //GB-1078音视频分离
                /* if (['GB-1078'].includes(T)) {
                  params.datatype = 0;
                } */

                let obj = playList.find(
                    (p) => p.device == device && p.channel == channel
                );
                if (obj) return;
                let tidObj = player.allocate(channelArr.length);
                if (tidObj.flag == 1) {
                    this.dingshiqi();
                    for (let i = 0; i < channelArr.length; i++) {
                        const param = {
                            ...params,
                            channel: channelArr[i],
                        };
                        let tid = tidObj.ids[i];
                        player.record.open(
                            tid,
                            param,
                            (res) => {
                                console.log('huifangxiangying', res);
                            },
                            {
                                hasAudio: 0, //GB-1078音视频分开，默认不请求音频
                            }
                        );
                        playList.push({
                            ...param,
                        });

                    }

                } else {
                    alert(tidObj.msg);
                }
            }, 500);
        },

        dingshiqi() {
            return;
            clearInterval(jishiqi);
            var start = this.playnow.start;
            var end = this.playnow.end;
            var now = start;
            jishiqi = setInterval(() => {
                now += 10;

                this.showWin(now);
                if (now > end) {
                    clearInterval(jishiqi)
                }
            }, 10000);
        },
        downloadFile(v) {
            //var v = this.alotItem;
            let params = {
                device: v.device,
                channel: v.channel,
                protocolType: 1,
                begintime: v.start,
                endtime: v.end,
                fileName: v.fileName,
                //plate: "测试车辆",
                //vehicleId: "4321",
                //groupId: "1"
            };
            player.ftp.downloadFile(params, (res) => {
                console.log(res);
                if (res.status == 2 && res.media_address) {
                    saveAsFile(res.media_address.video_address);
                }
            });
            function saveAsFile(src, filename) {
                let a = document.createElement("a");
                a.href = src;
                a.target = "_blank";
                a.download = filename || src.substr(src.lastIndexOf("/"));
                a.click();
            }
        },
        //Ga设备下载
        GadownloadFile() {
            var v = this.alotItem;
            let params = {
                device: v.device,
                channel: v.channel,
                protocolType: 1,
                begintime: v.start,
                endtime: v.end,

                fileName: null,
                //plate: "测试车辆",
                //vehicleId: "4321",
                //groupId: "1"
            };
            player.gaDownload.downloadFile(params, (res) => {
                console.log(res);
                if (res.status && res.media_address) {
                    saveAsFile(res.media_address.video_address);
                }
            });
            function saveAsFile(src, filename) {
                let a = document.createElement("a");
                a.href = src;
                a.target = "_blank";
                a.download = filename || src.substr(src.lastIndexOf("/"));
                a.click();
            }
        },

        pause(aaa) {
            let device = this.tableForm.deviceNo;
            clearInterval(jishiqi);
            this.yincangguiji();
            let channel = 1;
            //const channelArr = channel.split(",").map(p => p * 1);
            //const channelArr = [channel];
            const channelArr = this.tongdao;
            for (let i = 0; i < channelArr.length; i++) {
                let index = playList.findIndex(
                    (p) => p.device == device && p.channel == channelArr[i]
                );
                let obj = playList[index];
                if (obj)
                    player.record.close(
                        obj.tid,
                        {
                            device: device,
                            channel: obj.channel,
                            protocolType: obj.protocolType,
                        },
                        (res) => {
                            this.isPlay = true;
                        }
                    );
                playList.splice(index, 1);
            }
            this.isPlay = false;
        },
        close() {
            clearInterval(jishiqi);
            //this.yincangguiji();
            for (let i = 0; i < playList.length; i++) {

                let obj = playList[i];
                if (obj)
                    player.real.close(
                        obj.tid,
                        {
                            device: obj.device,
                            channel: obj.channel,
                            protocolType: obj.protocolType,
                        },
                        (res) => {
                            this.isPlay = true;
                        }
                    );

            }
            playList.splice(0, 100);
            this.$emit('closeVideo');

        },
        reCarNo(v) {
            this.tableForm = {
                carNo: v.carNo,
                deviceNo: v.deviceNo,
                deviceModel: v.deviceModel,
                deviceProtocol: v.deviceProtocol,
            };
            this.openVideo = false;
        },
        chuli() {
            var z = this.recolist;
            console.log('视频撇表', z)

            let list = [];
            for (let i = 1; i <= 6; i++) {
                var aa = {
                    channel: i,
                    times: [],
                };
                list.push(aa);
            }
            //找最小开始
            var arr1 = [], arr2 = []
            for (let i = 0; i < z.length; i++) {
                arr1.push(z[i].begintime);
                arr2.push(z[i].endtime);
            }
            arr1 = arr1.sort(function (a, b) {
                return a - b;
            });
            arr2 = arr2.sort(function (a, b) {
                return b - a;
            });


            let start = arr1[0] / 1000;
            let end = arr2[0] / 1000;

            //channel
            for (let i = 0; i < z.length; i++) {
                let zz = z[i];

                var obj = {
                    //alarmSign: 0,
                    start: zz.begintime / 1000,
                    channel: zz.channel,
                    //codetype: 1,
                    //datatype: 0,
                    device: zz.device,
                    end: zz.endtime / 1000,
                    fileName: zz.fileName,
                    filesize: zz.filesize,
                    size: (zz.filesize / (1024 * 1024)).toFixed(2),
                    duration: ((zz.endtime - zz.begintime) / 60000).toFixed(1),
                    begintime2: this.utils.time(zz.begintime),
                    endtime2: this.utils.time(zz.endtime),
                    //storgetype: 1,
                };
                for (let j = 1; j <= 4; j++) {
                    if (zz.channel == j) {
                        list[j - 1].times.push(obj);
                    }
                }

                /* if (zz.channel == 2) {
                  list[1].times.push(obj);
                }
                if (zz.channel == 3) {
                  list[2].times.push(obj);
                }
                if (zz.channel == 4) {
                  list[3].times.push(obj);
                } */
            }
            this.$refs.videoTool.reach(start, end, list);

        },
        alot(a, b) {
            this.openDetail = true;
            console.log(b);
            this.alotItem = b;
        },

    },
    mounted() {

        setTimeout(() => {
            this.beforCcreatePlayer();
        }, 200);
    },
    destroyed() {
        //location.reload();

        //m.appendChild(s);
    },
};
</script>
<style>
#vvideo {
    width: 100%;
    height: 100%;
    display: flex;
}

#ztvleft {
    width: 100%;
    height: 100%;
    background: black;
}

#ztvright {
    width: 30%;
    height: 100%;
}

#ztvleft #videoHistorywrap {
    height: calc(100% - 160px);
    width: 100%;
}

#ztvleft #videoctr {
    height: 36px;
    width: 100%;
    display: flex;
    background: #dce8fe;
    padding: 4px 0px;
    border-bottom: solid 4px #68acfb
}

#ztvleft #videoctr li {
    margin: 0 10px;
}

#ztvleft #videotool {
    height: 120px;
    width: 100%;
    background: #424242;
}

#ztvright #vvmap {
    height: calc(100% - 0px);
    width: 100%;
    background: green;
}

#ztvright #vvmaplist {
    height: 200px;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/video/historyVideoTool.vue